import { useLocation } from 'react-router-dom';

export const useRouteContext = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  const getContextualPath = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return isAdminRoute ? `/admin/${cleanPath}` : `/${cleanPath}`;
  };
  
  return {
    isAdminRoute,
    getContextualPath
  };
};